module.exports = __webpack_public_path__ + "img/download-file.173de659.svg";